import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store";
import { App } from "./App";
import { init } from "@telegram-apps/sdk";
import { initErrorLogger } from "./utils/errorLogger";
import "./index.css";

// Инициализация SDK только если мы в Telegram
const initTelegramSDK = () => {
  try {
    // Проверяем, что мы в Telegram окружении
    if (window.Telegram?.WebApp) {
      console.log("✅ Инициализация Telegram SDK...");
      init();
      console.log("✅ Telegram SDK инициализирован");
    } else {
      console.log("⚠️ Запуск вне Telegram - SDK не инициализирован");
    }
  } catch (error) {
    console.error("❌ Ошибка инициализации Telegram SDK:", error);
    // Не падаем, просто логируем
  }
};

// Инициализируем SDK
initTelegramSDK();
initErrorLogger();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
